import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'GEMSYS',
    logoBlack: require('@/assets/images/logos/Geminys CCMM.png'),
    logoWhite: require('@/assets/images/logos/Geminys CCMM Negativo.png'),
    minilogo: require('@/assets/images/logos/logo.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'default', // default, bordered, semi-dark
    contentWidth: 'boxed',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    isVerticalNavMax: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#F08330',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#2BA337',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#EA514F',
    },
    dark: {
      primary: '#F08330',
      accent: '#0d6efd',
      secondary: '#8A8D93',
      success: '#2BA337',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#EA514F',
    },
  },
}

export default themeConfig
